import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareLinesBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"square-lines-bottom, transcription"} maskId="square-filled-radius-0-stroke-1-IconSquareLinesBottom"><path fillRule="evenodd" clipRule="evenodd" d="M2 20V4H22V20H2ZM6 11V12H9V11H6ZM11 11V12H18V11H11ZM6 15V16H13V15H6ZM15 15V16H18V15H15Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSquareLinesBottom;
